// extracted by mini-css-extract-plugin
module.exports =  {"ui-claude-mcp-banner":"ClaudeMcpBanner-module_ui-claude-mcp-banner_b940b","ui-claude-mcp-banner__banner":"ClaudeMcpBanner-module_ui-claude-mcp-banner__banner_c9ffb"};